<template>
  <div class="shipping-container">
    <h2>Claim Check</h2>
    <div v-if="claimInfo" class="claim-instructions">
      <div class="but-wait">Enter a Token ID between {{ claimInfo.start_token_id }} and  {{ claimInfo.end_token_id }}</div>
      <IconicInput id="tokenId" v-model="tokenId" type="number" label="Token Id" :autofocus="'autofocus'"
                   :min="claimInfo.start_token_id"
                   :max="claimInfo.end_token_id"
      />
      <div style="margin: auto; text-align: center;">
        <button type="submit" class="check-button highlighted" @click="check()">Check Status</button>
      </div>
      <p v-if="claimMessage" class="claim-status">
        {{ claimMessage }}
      </p>
      <p class="claim-disclaimer">
        This check gives you the current claim status, helping you determine whether a token is still eligible for rewards.
        Keep in mind, the present owner can claim rewards while they still hold the NFT.
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import IconicInput from '../components/forms/IconicInput.vue'

export default {
  components: {
    IconicInput
  },
  data: () => ({
    tokenId: "",
    partnerSlug: ""
  }),
  computed: {
    ...mapState({
      claimMessage: state => state.claim.claimMessage,
      checkingClaim: state => state.claim.checkingClaim,
      claimInfo: state => state.claim.claimInfo,
      ethAddress: state => state.auth.account.address
    })
  },
  methods: {
    ...mapActions('claim', ['checkClaim', 'getClaimInfo']),
    check() {
      this.checkClaim({partnerSlug: this.partnerSlug, tokenId: this.tokenId})
    }
  },
  async created() {
    this.partnerSlug = this.$route.params.partner_slug
    this.getClaimInfo(this.partnerSlug)
  }
}
</script>

<style lang="scss" scoped>
h2 {
  font-family: $font-family-primary;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 0;

  @include on-laptop {
    font-size: 2.5rem;
  }
}
.but-wait, .but-wait a, .claim-status {
  margin: .5rem 0 .5em 0;
  font-family: $font-family-secondary;
  font-size: .8em;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--color-primary-one);
}
.shipping-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  @include container-sizer;
  margin-top: 2rem;

  @include on-laptop {
    margin-top: 3rem;
  }

  color: black;
  form {
    display: flex;
    flex-direction: column;
  }
  input[type='submit'] {
    margin-top: 1em;
  }
}
.claim-disclaimer {
  max-width: 320px;
  @include on-laptop {
    max-width: 600px;
  }
  font-family: $font-family-primary;
}
.check-button {
  font-family: $font-family-secondary;
  background-color: black;
  border: 0.4px solid black;
  border-radius: 3em;
  margin: 1em;
  padding: 0.8em 1.8em;
  font-size: .9em;
  color: white;
  width: fit-content;
  cursor: pointer;
  text-decoration: none;
  text-transform: uppercase;
}
</style>
